import { PlatePluginOptions } from "@udecode/plate-core";
import { DEFAULTS_PARAGRAPH, ELEMENT_PARAGRAPH } from "@udecode/plate-paragraph";
import { ELEMENT_LI, ELEMENT_OL, ELEMENT_UL } from "@udecode/plate-list";
import {
  DEFAULTS_BOLD,
  DEFAULTS_ITALIC,
  DEFAULTS_UNDERLINE,
  MARK_BOLD,
  MARK_ITALIC,
  MARK_UNDERLINE,
} from "@udecode/plate-basic-marks";

export type DefaultPlatePluginKey =
  | typeof ELEMENT_LI
  | typeof ELEMENT_OL
  | typeof ELEMENT_PARAGRAPH
  | typeof ELEMENT_UL
  | typeof MARK_BOLD
  | typeof MARK_ITALIC
  | typeof MARK_UNDERLINE;

export const createPlatePluginsOptions = <T extends string = string>(
  overrides?: Partial<Record<DefaultPlatePluginKey | T, Partial<PlatePluginOptions>>>
) => {
  const options: Record<DefaultPlatePluginKey, Partial<PlatePluginOptions>> = {
    [ELEMENT_LI]: {},
    [ELEMENT_OL]: {},
    [ELEMENT_PARAGRAPH]: DEFAULTS_PARAGRAPH,
    [ELEMENT_UL]: {},
    [MARK_BOLD]: DEFAULTS_BOLD,
    [MARK_ITALIC]: DEFAULTS_ITALIC,
    [MARK_UNDERLINE]: DEFAULTS_UNDERLINE,
  };

  if (overrides) {
    Object.keys(overrides).forEach((key) => {
      const override = overrides[key as DefaultPlatePluginKey];
      if (override) {
        options[key as DefaultPlatePluginKey] = override;
      }
    });
  }

  Object.keys(options).forEach((key) => {
    if (!options[key as DefaultPlatePluginKey].type) {
      options[key as DefaultPlatePluginKey].type = key;
    }
  });

  return options as Record<DefaultPlatePluginKey | T, PlatePluginOptions>;
};
